import { render, staticRenderFns } from "./menuComponent.vue?vue&type=template&id=21106adb"
import script from "./menuComponent.vue?vue&type=script&lang=js"
export * from "./menuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports